module.exports = __webpack_public_path__ + "static/media/call_for_paper_wallpaper_2.da97f7ed.jpg";